import React, { memo, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import HomePage from "./pages/HomePage";

const AboutUs = lazy(() => import("./components/AboutUs"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsOfServicePage = lazy(() => import("./pages/TermsOfServicePage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const App = memo(() => {

  return (
    <AppProvider>
      <BrowserRouter>
        <div className="App">
          <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-[9999] focus:top-4 focus:left-4 focus:bg-kumia-green focus:text-white focus:px-4 focus:py-2 focus:rounded-lg">
            Saltar al contenido principal
          </a>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/sobre-nosotros" element={<Suspense fallback={<div className="min-h-screen bg-[#060B14]" />}><AboutUs /></Suspense>} />
            <Route path="/privacidad" element={<Suspense fallback={<div className="min-h-screen bg-white" />}><PrivacyPolicyPage /></Suspense>} />
            <Route path="/terminos" element={<Suspense fallback={<div className="min-h-screen bg-white" />}><TermsOfServicePage /></Suspense>} />
            <Route path="*" element={<Suspense fallback={<div className="min-h-screen bg-[#060B14]" />}><NotFoundPage /></Suspense>} />
          </Routes>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
});

App.displayName = 'App';

export default App;